var map = {
	"./_testimonials": "bW+r",
	"./de_testimonials": "m6aS",
	"./es_testimonials": "Mvy/",
	"./fr_testimonials": "5ju/",
	"./keto_testimonials": "uCxj",
	"./pt_testimonials": "sMQ2"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "JJRw";